export const getClientReadableText = (text: string) => {
  const setLowerCase = text.toLowerCase();
  const splitUsingUnderscoreArray = setLowerCase.split("_");
  const upperCaseForFirstLetterArray = splitUsingUnderscoreArray.map(
    (text: string) => {
      return text.charAt(0).toUpperCase() + text.slice(1);
    }
  );
  return upperCaseForFirstLetterArray.join(" ");
};

export const getFormattedTBWExtraDataArray = (extraData: string) => {
  try {
    const parsedData: string[] = JSON.parse(extraData);
    return parsedData.map((item) => item.trim()).join(", ");
  } catch {
    return "";
  }
};
